import React from "react";

function ManualOrderModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-xl">
                <div className="border-b px-6 py-4 flex justify-between items-center">
                    <h2 className="text-xl font-bold text-custom-green">
                        Manual Order
                    </h2>

                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

                <div className="p-6">
                    <p className="text-gray-600">
                        Manual order form will be added here.
                    </p>
                </div>

                <div className="border-t px-6 py-4 flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                    >
                        Cancel
                    </button>

                    <button className="px-4 py-2 bg-custom-green text-white rounded-lg hover:bg-opacity-90">
                        Save Order
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ManualOrderModal;